module.exports = __webpack_public_path__ + "slider-01@2x.jpg?8f62ef79b8d5a278fbadfe8a813a9242";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-01@2x.jpg
// module id = 264
// module chunks = 0